import React from 'react';
export default function CurrentYearQEComparisonToPreviousYear(_ref) {
  let {
    dashboardData
  } = _ref;
  if (dashboardData.prev_claim_total_qualifying_rnd_expenditure === null) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  /*
  the qeDifferenceAsPercentageOfLastYear is:
    1) the percentage if last year's value is not 0
    2) 0 - if last year's value is 0, and the current value is 0 - hence the qeDifference is 0-0=0
    3) 100 if the current year value is not 0 - hence qeDifference > 0, and last year's value is 0
  */
  const qeDifference = dashboardData.total_qualifying_rnd_expenditure - dashboardData.prev_claim_total_qualifying_rnd_expenditure;
  let qeDifferenceAsPercentageOfLastYear = 0;
  if (dashboardData.prev_claim_total_qualifying_rnd_expenditure > 0) {
    qeDifferenceAsPercentageOfLastYear = Math.abs(qeDifference) / dashboardData.prev_claim_total_qualifying_rnd_expenditure * 100;
  } else if (qeDifference > 0) {
    qeDifferenceAsPercentageOfLastYear = 100;
  }
  const qeDifferenceSign = qeDifference >= 0 ? '' : '-';
  qeDifferenceAsPercentageOfLastYear = window.MARKET_CONSTANTS.PERCENTAGE_FORMATTER.format(qeDifferenceAsPercentageOfLastYear);
  const prevClaimYear = Object.keys(dashboardData.total_costs_and_qe_costs_per_year).findLast(year => year < dashboardData.current_accounting_period);
  return /*#__PURE__*/React.createElement("h6", {
    style: {
      color: '#393939'
    }
  }, qeDifferenceSign, qeDifferenceAsPercentageOfLastYear, "% Increase on ", prevClaimYear);
}